/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AnswerDto from '../model/AnswerDto';
import AnswerInputDto from '../model/AnswerInputDto';
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PaginatedAnswersDto from '../model/PaginatedAnswersDto';

/**
* Answer service.
* @module api/AnswerApi
* @version v0
*/
export default class AnswerApi {

    /**
    * Constructs a new AnswerApi. 
    * @alias module:api/AnswerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createAnswer operation.
     * @callback module:api/AnswerApi~createAnswerCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AnswerDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new answer
     * @param {module:model/AnswerInputDto} answerInputDto 
     * @param {module:api/AnswerApi~createAnswerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AnswerDto}
     */
    createAnswer(answerInputDto, callback) {
      let postBody = answerInputDto;
      // verify the required parameter 'answerInputDto' is set
      if (answerInputDto === undefined || answerInputDto === null) {
        throw new Error("Missing the required parameter 'answerInputDto' when calling createAnswer");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = AnswerDto;
      return this.apiClient.callApi(
        '/api/private/answer', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAnswerById operation.
     * @callback module:api/AnswerApi~deleteAnswerByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a answer by ID
     * @param {Number} id ID of the answer to delete
     * @param {module:api/AnswerApi~deleteAnswerByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAnswerById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteAnswerById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/answer/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAnswerById operation.
     * @callback module:api/AnswerApi~getAnswerByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AnswerDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a answer by ID
     * @param {Number} id ID of the answer to update
     * @param {module:api/AnswerApi~getAnswerByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AnswerDto}
     */
    getAnswerById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getAnswerById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = AnswerDto;
      return this.apiClient.callApi(
        '/api/private/answer/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAnswers operation.
     * @callback module:api/AnswerApi~getAnswersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedAnswersDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all answers
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {module:api/AnswerApi~getAnswersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedAnswersDto}
     */
    getAnswers(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedAnswersDto;
      return this.apiClient.callApi(
        '/api/private/answer', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateAnswerById operation.
     * @callback module:api/AnswerApi~updateAnswerByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AnswerDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing answer
     * Update an existing answer by ID
     * @param {Number} id ID of the answer to update
     * @param {module:model/AnswerDto} answerDto 
     * @param {module:api/AnswerApi~updateAnswerByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AnswerDto}
     */
    updateAnswerById(id, answerDto, callback) {
      let postBody = answerDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateAnswerById");
      }
      // verify the required parameter 'answerDto' is set
      if (answerDto === undefined || answerDto === null) {
        throw new Error("Missing the required parameter 'answerDto' when calling updateAnswerById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = AnswerDto;
      return this.apiClient.callApi(
        '/api/private/answer/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
